import styled from 'styled-components/macro';

export const NavBar = styled.nav`
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-end;
  gap: 16px;
`;
